module.exports = __webpack_public_path__ + "static/media/cheerful-happy.140b0454.png";